'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');
const theme_Colors = require('../../../theme/Colors.cjs.js');
require('../../../theme/Shadows.cjs.js');
require('../../../theme/Typography.cjs.js');
const theme_Zindexes = require('../../../theme/Zindexes.cjs.js');
const hooks_useClickOutside = require('../../../hooks/useClickOutside.cjs.js');
const hooks_useIntersect = require('../../../hooks/useIntersect.cjs.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const root = "_root_1aftq_15";
const menuOpen = "_menu-open_1aftq_1";
const box = "_box_1aftq_40";
const styles = {
	root: root,
	menuOpen: menuOpen,
	box: box
};

function getBackgroundColor(hasWhiteBackground = false) {
  return hasWhiteBackground ? "#fff" : theme_Colors.Colors.BackgroundWeaker;
}
const FloatingBox = ({ children, hasWhiteBackground = void 0, intersectHeight = void 0, maxWidth = void 0, minWidth = void 0, onClickOutside = () => {
}, align = "left", position = void 0, borderRadius, borderColor = theme_Colors.Colors.StrokeWeaker }) => {
  const threshold = 0.9;
  const node = React.useRef(null);
  const [setIntersectNode, { isBottomIntersecting, isTopIntersecting }] = hooks_useIntersect.useIntersect({
    heightOverride: intersectHeight,
    once: true,
    threshold
  });
  const backgroundColor = getBackgroundColor(hasWhiteBackground);
  const [setClickOutsideNode] = hooks_useClickOutside.useClickOutside({
    onClickOutside
  });
  React.useEffect(() => {
    setIntersectNode(node.current);
    setClickOutsideNode(node.current);
  }, [setClickOutsideNode, setIntersectNode]);
  const derivedState = {
    position: position || (isTopIntersecting || !isBottomIntersecting ? "south" : "north")
  };
  return React__default.default.createElement(
    "div",
    { className: styles.root, "data-align": align, "data-position": derivedState.position, ref: node, "data-testid": "floating-box", "data-zds": true, style: {
      "--_zds-floating-box-max-width": maxWidth !== null && maxWidth !== void 0 ? maxWidth : "",
      "--_zds-floating-box-min-width": minWidth !== null && minWidth !== void 0 ? minWidth : "",
      "--_zds-floating-box-z-index": theme_Zindexes.Zindexes.dropdownMenu
    } },
    React__default.default.createElement("div", { className: styles.box, style: {
      "--_zds-floating-box-background-color": backgroundColor,
      "--_zds-floating-box-border-color": borderColor,
      "--_zds-floating-box-border-radius": `var(--zds-radius-${borderRadius !== null && borderRadius !== void 0 ? borderRadius : "default"})`
    } }, children)
  );
};

exports.FloatingBox = FloatingBox;
//# sourceMappingURL=FloatingBox.cjs.js.map
